import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import InspectionHistory from './inspection-history';
import InspectionHistoryDetail from './inspection-history-detail';
import InspectionHistoryUpdate from './inspection-history-update';
import InspectionHistoryDeleteDialog from './inspection-history-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={InspectionHistoryUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={InspectionHistoryUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={InspectionHistoryDetail} />
      <ErrorBoundaryRoute path={match.url} component={InspectionHistory} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={InspectionHistoryDeleteDialog} />
  </>
);

export default Routes;
